/* SD mobile clearance: no requests, no trackers, no cart interception. */
(function () {
  'use strict';
  var root = document.documentElement;
  if (!root.hasAttribute('data-sd-mobile-shopping') || window.sdMobileShoppingClearance) return;
  window.sdMobileShoppingClearance = true;
  var media = window.matchMedia('(max-width: 767px)');
  var selector = '.sd-pdp-rail, [data-sd-cart-fastbar], .stickyCart';
  var watched = new Set(), frame = 0, last = -1;
  var resize = window.ResizeObserver ? new ResizeObserver(schedule) : null;
  function schedule() {
    if (!frame) frame = window.requestAnimationFrame(update);
  }
  function update() {
    frame = 0;
    var bars = Array.from(document.querySelectorAll(selector));
    watched.forEach(function (el) {
      if (!el.isConnected) { if (resize) resize.unobserve(el); watched.delete(el); }
    });
    var clearance = 0;
    bars.forEach(function (el) {
      if (!watched.has(el)) { watched.add(el); if (resize) resize.observe(el); }
      if (!media.matches || el.hidden) return;
      var css = window.getComputedStyle(el), box = el.getBoundingClientRect();
      if (css.display === 'none' || css.visibility === 'hidden' || Number(css.opacity) === 0 ||
          css.position !== 'fixed' || !box.width || !box.height) return;
      // Our purchase bars are anchored to the layout viewport. Ignore unrelated side panels.
      if (box.bottom >= window.innerHeight - 2 && box.top < window.innerHeight && box.top >= 0) {
        clearance = Math.max(clearance, Math.ceil(window.innerHeight - box.top));
      }
    });
    if (clearance !== last) {
      root.style.setProperty('--sd-purchase-clearance', clearance + 'px');
      last = clearance;
    }
    if (media.matches) {
      document.querySelectorAll('.wa__btn_popup').forEach(function (button) {
        // Keep a name when the floating text label is visually hidden. Do not replace app behavior.
        if (!button.hasAttribute('aria-label') && !button.hasAttribute('aria-labelledby')) {
          button.setAttribute('aria-label', /^ar(?:-|$)/i.test(root.lang) ? 'المساعدة عبر واتساب' : 'WhatsApp help');
        }
      });
    }
  }
  function init() {
    update();
    new MutationObserver(function (records) {
      if (records.some(function (record) {
        if (record.type === 'childList') return record.addedNodes.length || record.removedNodes.length;
        var el = record.target;
        return el === root || el === document.body || (el.matches && (el.matches(selector) || el.closest(selector)));
      })) schedule();
    }).observe(root, {subtree:true,childList:true,attributes:true,attributeFilter:['class','hidden']});
    window.addEventListener('resize', schedule, {passive:true});
    window.addEventListener('pageshow', schedule);
    if (window.visualViewport) window.visualViewport.addEventListener('resize', schedule, {passive:true});
    if (media.addEventListener) media.addEventListener('change', schedule);
    else if (media.addListener) media.addListener(schedule);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
}());
